import styles from './OngoingLoanView.module.css';
import RepayEarly from './RepayEarly';
import OrderSummary from '../../../orderSummary/OrderSummary';
import { OngoingPaymentPlan } from '../../Dashboard.types';

const OngoingLoanView = ({
    paymentPlan: { account, interestRate, principle }
}: {
    paymentPlan: OngoingPaymentPlan;
}) => {
    return (
        <div className={styles.OngoingView} data-testid="ongoing-view">
            <div className={styles.orderSection}>
                <div className={styles.repaymentWrapper}>
                    <RepayEarly account={account} />
                </div>

                <OrderSummary
                    orderAmount={principle}
                    interestRate={interestRate}
                    account={account}
                    title={null}
                />
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default OngoingLoanView;
